import { ActionStatusCodes } from './ActionStatusCodes';
import { ActionTakenCodes } from './ActionTakenCodes';
import { AssociatedEids } from './AssociatedEids';
import { InQueue } from './InQueue';
import { Notes } from './Notes';
import { RecordAgeInPath } from './RecordAgeInPath';
import { SourceRecordsRemediated } from './SourceRecordsRemediated';

export const ActionStatusCodesWidget = ActionStatusCodes;
export const ActionTakenCodesWidget = ActionTakenCodes;
export const InQueueWidget = InQueue;
export const RecordAgeInPathWidget = RecordAgeInPath;
export const SourceRecordsRemediatedWidget = SourceRecordsRemediated;
export const NotesWidget = Notes;
export const AssociatedEidsWidget = AssociatedEids;

/**
 * Widgets
 *
 * @type {{ASSOCIATED_EIDS: ((function(*): Element)|*), NOTES: ((function(*): Element)|*), IN_QUEUE: ((function(*):
 *     Element)|*), ACTION_STATUS_CODES: ((function(*): Element)|*), SOURCE_RECORDS_REMEDIATED: ((function(*):
 *     Element)|*), ACTION_TAKEN_CODES: ((function(*): Element)|*), RECORD_AGE_IN_PATH: ((function(*): Element)|*)}}
 */
export const widgets = {
  ACTION_STATUS_CODES: ActionStatusCodesWidget,
  ACTION_TAKEN_CODES: ActionTakenCodesWidget,
  ASSOCIATED_EIDS: AssociatedEidsWidget,
  IN_QUEUE: InQueueWidget,
  NOTES: NotesWidget,
  RECORD_AGE_IN_PATH: RecordAgeInPathWidget,
  SOURCE_RECORDS_REMEDIATED: SourceRecordsRemediatedWidget,
};
